/* eslint unicode-bom: ["error", "always"] */
import React, { useState, useEffect } from 'react';
import { Header } from "./header";
import { Footer } from "./footer";
import { Contact } from './contact';
import JsonData from "./data.json";
import "./assets/index.css";
import { Join } from './join';

const AboutBuilde = () => {
  const [pageData, setPageData] = useState({});

  useEffect(() => {
    setPageData(JsonData);
  }, []);

  return (
    <div>
      <Header data={pageData.Header} />
      <Join data={pageData.Join} />
      <Contact data={pageData.Contact} />
      <Footer data={pageData.Footer} />
    </div>
  );
};

export default AboutBuilde;
